import styled from "styled-components";

export const Container = styled.div`
	display: inline-block;
`;

export const CtaWithIcon = styled.a`
	text-decoration: none;
	.link-text {
		color: ${({ darkBg }) =>
			darkBg ? "var(--secondary-purple-100)" : "var(--secondary-purple-300)"};
	}
	color: ${(props) =>
		props.darkBg
			? props.disabled
				? "var(--secondary-gray-medium) !important"
				: "var(--primary-neutral-white)"
			: props.disabled
				? "var(--secondary-gray-dark) !important"
				: "var(--primary-neutral-nightshade-800)"};
	& p {
		color: ${(props) =>
			props.darkBg
				? props.disabled
					? "var(--secondary-gray-medium) !important"
					: "var(--primary-neutral-white)"
				: props.disabled
					? "var(--secondary-gray-dark) !important"
					: "var(--primary-neutral-nightshade-800)"};
	}
	display: flex;
	flex-direction: ${(props) => (props.iconRight ? "row-reverse" : "row")};
	align-items: center;
	margin-right: auto;
	gap: 0.5rem;
	&:hover {
		color: ${(props) =>
			props.darkBg
				? props.disabled
					? "var(--secondary-gray-medium) !important"
					: "var(--secondary-purple-100)"
				: props.disabled
					? "var(--secondary-gray-dark) !important"
					: "var(--secondary-purple-300)"};
	}
	${(props) => (props.disabled ? "pointer-events: none;" : "cursor: pointer;")}

	.arrowWrapper {
		position: inherit;
		width: 1rem;
	}
	.hovered-link {
		transition: 200ms ease;
	}
`;

export const ArrowSvg = styled.svg`
	height: 0.75rem;
	width: 1rem;
	transition: 200ms width ease;
	display: flex;
	align-items: center;
	position: absolute;
	top: 0;
	transform: translateY(-50%);
	left: 0;

	${CtaWithIcon}:hover & {
		width: 1.5rem;
		margin-right: -0.5rem;
	}
`;

export const ArrowPath = styled.path`
	fill: ${(props) =>
		props.darkBg
			? props.disabled
				? "var(--secondary-gray-medium) !important"
				: "var(--secondary-purple-100)"
			: props.disabled
				? "var(--secondary-gray-dark) !important"
				: "var(--secondary-purple-300)"};
	height: 100%;
	transition: 200ms d ease;
	d: path(
		"M9.60867 1.10714L10.9988 0C11.5413 0.940476 12.0725 1.76786 12.5924 2.48214C13.1236 3.18452 13.6661 3.81548 14.2199 4.375C14.7737 4.93452 15.3671 5.45833 16 5.94643V6.05357C15.3671 6.52976 14.7737 7.04762 14.2199 7.60714C13.6661 8.16667 13.1236 8.80357 12.5924 9.51786C12.0725 10.2202 11.5413 11.0476 10.9988 12L9.60867 10.875C10.0721 10.125 10.5467 9.45238 11.0327 8.85714C11.5187 8.26191 12.0047 7.75 12.4907 7.32143C12.9767 6.88095 13.4514 6.52976 13.9148 6.26786C14.3782 5.99405 14.8189 5.80357 15.2371 5.69643V6.30357C14.8189 6.19643 14.3782 6.00595 13.9148 5.73214C13.4514 5.45833 12.9767 5.10714 12.4907 4.67857C12.0047 4.23809 11.5187 3.72619 11.0327 3.14286C10.5467 2.54762 10.0721 1.86905 9.60867 1.10714ZM0 5.03571H10.1173C10.8858 5.03571 11.5809 5.06548 12.2025 5.125C12.8354 5.18452 13.4062 5.2619 13.9148 5.35714L15.0506 6L13.9148 6.64286C13.4062 6.72619 12.8354 6.79762 12.2025 6.85714C11.5809 6.91667 10.8858 6.94643 10.1173 6.94643H0V5.03571Z"
	);
	d: "M9.60867 1.10714L10.9988 0C11.5413 0.940476 12.0725 1.76786 12.5924 2.48214C13.1236 3.18452 13.6661 3.81548 14.2199 4.375C14.7737 4.93452 15.3671 5.45833 16 5.94643V6.05357C15.3671 6.52976 14.7737 7.04762 14.2199 7.60714C13.6661 8.16667 13.1236 8.80357 12.5924 9.51786C12.0725 10.2202 11.5413 11.0476 10.9988 12L9.60867 10.875C10.0721 10.125 10.5467 9.45238 11.0327 8.85714C11.5187 8.26191 12.0047 7.75 12.4907 7.32143C12.9767 6.88095 13.4514 6.52976 13.9148 6.26786C14.3782 5.99405 14.8189 5.80357 15.2371 5.69643V6.30357C14.8189 6.19643 14.3782 6.00595 13.9148 5.73214C13.4514 5.45833 12.9767 5.10714 12.4907 4.67857C12.0047 4.23809 11.5187 3.72619 11.0327 3.14286C10.5467 2.54762 10.0721 1.86905 9.60867 1.10714ZM0 5.03571H10.1173C10.8858 5.03571 11.5809 5.06548 12.2025 5.125C12.8354 5.18452 13.4062 5.2619 13.9148 5.35714L15.0506 6L13.9148 6.64286C13.4062 6.72619 12.8354 6.79762 12.2025 6.85714C11.5809 6.91667 10.8858 6.94643 10.1173 6.94643H0V5.03571Z";

	${CtaWithIcon}:hover & {
		d: path(
			"M17.6087 1.10714L18.9988 0C19.5413 0.940476 20.0725 1.76786 20.5924 2.48214C21.1236 3.18452 21.6661 3.81548 22.2199 4.375C22.7737 4.93452 23.3671 5.45833 24 5.94643V6.05357C23.3671 6.52976 22.7737 7.04762 22.2199 7.60714C21.6661 8.16667 21.1236 8.80357 20.5924 9.51786C20.0725 10.2202 19.5413 11.0476 18.9988 12L17.6087 10.875C18.0721 10.125 18.5467 9.45238 19.0327 8.85714C19.5187 8.2619 20.0047 7.75 20.4907 7.32143C20.9767 6.88095 21.4514 6.52976 21.9148 6.26786C22.3782 5.99405 22.8189 5.80357 23.2371 5.69643V6.30357C22.8189 6.19643 22.3782 6.00595 21.9148 5.73214C21.4514 5.45833 20.9767 5.10714 20.4907 4.67857C20.0047 4.23809 19.5187 3.72619 19.0327 3.14286C18.5467 2.54762 18.0721 1.86905 17.6087 1.10714ZM0 5.03571H18.1173C18.8858 5.03571 19.5809 5.06548 20.2025 5.125C20.8354 5.18452 21.4062 5.2619 21.9148 5.35714L23.0506 6L21.9148 6.64286C21.4062 6.72619 20.8354 6.79762 20.2025 6.85714C19.5809 6.91667 18.8858 6.94643 18.1173 6.94643H0V5.03571Z"
		);
		d: "M17.6087 1.10714L18.9988 0C19.5413 0.940476 20.0725 1.76786 20.5924 2.48214C21.1236 3.18452 21.6661 3.81548 22.2199 4.375C22.7737 4.93452 23.3671 5.45833 24 5.94643V6.05357C23.3671 6.52976 22.7737 7.04762 22.2199 7.60714C21.6661 8.16667 21.1236 8.80357 20.5924 9.51786C20.0725 10.2202 19.5413 11.0476 18.9988 12L17.6087 10.875C18.0721 10.125 18.5467 9.45238 19.0327 8.85714C19.5187 8.2619 20.0047 7.75 20.4907 7.32143C20.9767 6.88095 21.4514 6.52976 21.9148 6.26786C22.3782 5.99405 22.8189 5.80357 23.2371 5.69643V6.30357C22.8189 6.19643 22.3782 6.00595 21.9148 5.73214C21.4514 5.45833 20.9767 5.10714 20.4907 4.67857C20.0047 4.23809 19.5187 3.72619 19.0327 3.14286C18.5467 2.54762 18.0721 1.86905 17.6087 1.10714ZM0 5.03571H18.1173C18.8858 5.03571 19.5809 5.06548 20.2025 5.125C20.8354 5.18452 21.4062 5.2619 21.9148 5.35714L23.0506 6L21.9148 6.64286C21.4062 6.72619 20.8354 6.79762 20.2025 6.85714C19.5809 6.91667 18.8858 6.94643 18.1173 6.94643H0V5.03571Z";
	}
`;

export const CtaWithoutIcon = styled.a`
	${(props) => (props.disabled ? "pointer-events: none;" : "cursor: pointer;")}
	text-decoration: none;
	color: ${(props) =>
		props.darkBg
			? props.disabled
				? "var(--secondary-gray-medium)"
				: "var(--secondary-purple-100)"
			: props.disabled
				? "var(--secondary-gray-dark)"
				: "var(--secondary-purple-300)"};
`;
